const QUERY_KEYS = {
    CHECK_ENVIRONMENT_CREATION: 'CHECK_ENVIRONMENT_CREATION',
    TENANT_DETAILS: 'TENANT_DETAILS',
    AWS_AUTONOMOUS_POLICY: 'AWS_AUTONOMOUS_POLICY',
    AWS_READ_ONLY_POLICY: 'AWS_READ_ONLY_POLICY',
    GET_ENRICH_FORM: 'GET_ENRICH_FORM',

};

export default QUERY_KEYS;